import React, { Component } from 'react';
import Icon from '@ant-design/icons';
import Style from './style';

const MessageSvg = () => (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" aria-hidden="true">
        <path fillRule="evenodd" clipRule="evenodd" d="M6.93476 16H7.02413H7.042C7.05988 16 7.07328 15.9955 7.08669 15.9911C7.10009 15.9866 7.11349 15.9821 7.13137 15.9821C7.14241 15.9821 7.16029 15.9753 7.18499 15.9658L7.185 15.9658L7.18507 15.9658C7.20031 15.96 7.21816 15.9531 7.23861 15.9463H7.25648C7.27435 15.9463 7.27435 15.9463 7.3101 15.9105C7.3101 15.9105 7.3101 15.8926 7.32797 15.8926C7.34584 15.8926 7.34584 15.8926 7.36372 15.8747L9.72297 13.5123H17.9982C19.1063 13.5123 20 12.6174 20 11.5078V2.00447C20 0.894854 19.1063 0 17.9982 0H2.00179C0.893655 0 0 0.894854 0 2.00447V11.5078C0 12.6174 0.893655 13.5123 2.00179 13.5123H5.20107L6.54155 15.7673L6.5773 15.8031C6.58835 15.8031 6.59257 15.81 6.5984 15.8194C6.602 15.8253 6.60622 15.8321 6.61305 15.8389C6.63092 15.8389 6.63092 15.8568 6.63092 15.8568H6.64879L6.66667 15.8747C6.70241 15.9105 6.72029 15.9284 6.77391 15.9463C6.79178 15.9642 6.82752 15.9821 6.8454 15.9821C6.86327 16 6.89902 16 6.93476 16ZM4 8C4.55228 8 5 7.55228 5 7C5 6.44772 4.55228 6 4 6C3.44772 6 3 6.44772 3 7C3 7.55228 3.44772 8 4 8ZM11 7C11 7.55228 10.5523 8 10 8C9.44771 8 9 7.55228 9 7C9 6.44772 9.44771 6 10 6C10.5523 6 11 6.44772 11 7ZM16 8C16.5523 8 17 7.55228 17 7C17 6.44772 16.5523 6 16 6C15.4477 6 15 6.44772 15 7C15 7.55228 15.4477 8 16 8Z" fill="currentColor"/>
    </svg>
)

class MessageIcon extends Component {
    constructor (props) {
        super(props);
    }

    render () {
        return (
            <Icon className={`cicon ${this.props.className||''}`} style={Object.assign({},Style,this.props.style)} component={MessageSvg} aria-hidden="true" />
        )
    }
}
export default MessageIcon;
